import { Donvi } from './donvi';

export class Tiepcongdan {
  id: number;
  thoigian: Date;
  thoigiangio: number;
  thoigianphut: number;
  thoigiangiay: number;
  nguoitiep: String;
  noidung: String;
  diadiem: String;
  dmdonvi: Donvi;
  dmdonviid: number;
  isactive: number;
  createddate: Date;
  createdbyuserid: number;
  modifieddate: Date;
  modifiedbyuserid: number;
  thang:number;
  khongtiepdan: number;
  filedinhkem: string;
  getFiles : string[];
}